import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/RCS-Logo-White.png";

const Navbar = () => {
  const [dateTime, setDateTime] = useState(new Date());
  const navigate = useNavigate();

  // Update date & time every second
  useEffect(() => {
    const timer = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const goToLoginLayout = () => navigate("/auth/login");
  const goHome = () => navigate("/");

  const formatDateTime = (date) =>
    date.toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "Asia/Manila",
    });

  const [day, rest] = formatDateTime(dateTime).split(",");

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 font-poppins bg-blue shadow-md border-b border-blue">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4 md:py-6">
            {/* Logo + Company Name */}
            <button
              type="button"
              onClick={goHome}
              className="flex items-center gap-4 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 rounded-xl"
              aria-label="Go to homepage"
              title="RCS Logistics — Home"
            >
              <img
                src={Logo}
                alt="RCS Logistics Philippines"
                className="h-8 md:h-10 w-auto"
              />
              <div className="hidden sm:block text-left">
                <h2 className="font-bold text-lg text-white">RCS LOGISTICS</h2>
                <p className="text-xs font-medium text-white/80">
                  Your Trusted Shipping Partner
                </p>
              </div>
            </button>

            {/* Right Section - DateTime & Login */}
            <div className="flex items-center gap-4 md:gap-6">
              <div className="hidden md:flex flex-col items-end">
                <div className="text-sm font-semibold text-white">{day}</div>
                <div className="text-xs text-white/80">{rest}</div>
              </div>

              {/* Login Button with enhanced hover/active/focus effects */}
              <button
                onClick={goToLoginLayout}
                className="group px-6 py-3 rounded-2xl font-bold text-sm 
                           bg-yellow text-blue shadow-md 
                           hover:bg-yellow/90 hover:text-blue-800 hover:shadow-lg 
                           active:scale-95 active:shadow 
                           transition-all duration-300 transform 
                           focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60
                           flex items-center gap-2"
                title="Open Login Portal"
                aria-label="Open Login Portal"
              >
                <i
                  className="fas fa-sign-in-alt text-sm transition-transform duration-300 group-hover:-translate-x-0.5"
                  aria-hidden="true"
                />
                <span className="hidden sm:inline">Login Portal</span>
                <span className="sm:hidden">Login</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Spacer for fixed navbar */}
      <div className="h-20 md:h-24" />
    </>
  );
};

export default Navbar;
